import axios from "axios"
import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS } from "./actionType"


export const Login = (userLogin) => (dispatch) => {
    console.log("before requst")
    dispatch({ type: LOGIN_REQUEST })
    console.log("after req")
    return (
        axios.get("https://anthro-backen.onrender.com/users", userLogin).then((res) => {
            console.log("user", res)
            dispatch({ type: LOGIN_SUCCESS, payload: res.email })
            console.log(res.data)
        }).catch((err) => {
            dispatch({ type: LOGIN_FAILURE, payload: err.message })
        })

    )
}


export const signup=(data)=>(dispatch)=>{
    return axios.post("https://anthro-backen.onrender.com/users",{data})
}
